const app = angular.module('msi.products', [
  require('@ordergroove/brandy/src/app/frequency'),
  require('@ordergroove/brandy/src/app/subscriptions'),
  require('@ordergroove/brandy/src/app/quantity'),
  require('@ordergroove/brandy/src/app/one-time-differences'),
  require('@ordergroove/brandy/src/app/core/constants'),
  require('@ordergroove/brandy/src/app/utils'),
  require('./product'),
  require('./image'),
  require('./price'),
  require('./item-controls')
]);


require('./sku-swap/on-change-product');

app.service('productsService', require('./products.service'));
app.component('ogSkuSwap', require('./sku-swap/sku-swap'));

module.exports = app.name;
